import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import application from './application';

Vue.use(Vuex);
axios.defaults.baseURL = process.env.API_URL || 'http://192.168.101.228:8000';


export default function () {
  const Store = new Vuex.Store({
    modules: {
      application,
    },
  });

  return Store;
}
